import Api from "app/services/common/Api";
import { CoSearchModel } from "app/model/common/coModel";
import { DcGridSplyDataModel, DcSplySeason } from "app/model/pc/dcgridSplyModel";

export class DcUserService extends Api {
  private static service: DcUserService;

  public static getInstance(): DcUserService {
    if (!DcUserService.service) {
      DcUserService.service = new DcUserService();
    }
    return DcUserService.service;
  }

  // 사용자 > 생산소비 > DC 그리드 공급량 조회
  public async getDcSplys(search: CoSearchModel) {
    const url = process.env.REACT_APP_URL_CO + "/dcgrid";
    return await super.get<DcGridSplyDataModel[]>(url, search);
  }

  // 사용자 > 보고서 > DC 공급 현황 - 전기요금 절감액 분석
  public async getDcSplySeason(fromDt: string) {
    const url = process.env.REACT_APP_URL_CO + '/dcgrid/sply/season';
    return await super.get<DcSplySeason>(url, { fromDt: fromDt });
  }

  // 사용자 > 보고서 > DC 공급 현황 > 공급량 > 평균 공급 시간
  // fromDt: 검색 하는 가장 마지막 일 보내야함
  public async getDcSplyAvgTime(search: {searchType: string, fromDt: string}) {
    if ('MONTH' === search.searchType.toUpperCase()) {
      const url = process.env.REACT_APP_URL_CO + '/dcgrid/sply/time/year';
      return await super.get<{ pwrSplyTime: number, pwrSplyDay: number }>(url, { fromDt: search.fromDt });
    } else if ('DAY' === search.searchType.toUpperCase()) {
      const url = process.env.REACT_APP_URL_CO + '/dcgrid/sply/time/month';
      return await super.get<{ pwrSplyTime: number, pwrSplyDay: number }>(url, { fromDt: search.fromDt });
    }
  }
}